"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transfer = void 0;
const Account_1 = require("./Account");
const utils_1 = require("../utils");
class Transfer {
    constructor(from, to, quantity, symbol, chain, contract, time, blockNum, count, trxId, memo) {
        this._from = new Account_1.Account(from);
        this._to = new Account_1.Account(to);
        this._quantity = utils_1.convertQuantity(quantity, chain);
        this._symbol = symbol;
        this._chain = chain;
        this._contract = contract;
        this._time = time;
        this._blockNum = blockNum;
        this._count = count;
        this._trxId = trxId;
        this._memo = memo;
    }
    static fromJson(value) {
        return new Transfer(value.from, value.to, value.quantity, value.symbol, value.chain, value.contract, value.time === undefined ? undefined : new Date(value.time), value.block_num, value.count, value.trx_id, value.memo);
    }
    toString() {
        return JSON.stringify(this.toJson);
    }
    toJson() {
        return {
            from: this._from,
            to: this._to,
            quantity: this._quantity,
            symbol: this._symbol,
            chain: this._chain,
            contract: this._contract,
            time: this._time,
            block_num: this._blockNum,
            count: this._count,
            trx_id: this._trxId,
            memo: this._memo,
        };
    }
    /**
     * @returns <code>false</code> if this is a single transfer or <code>true</code> if multiple transfers have been accumulated.
     */
    isAccumulated() {
        return !!this.count;
    }
    /**
     * @returns the sender account.
     */
    get from() {
        return this._from;
    }
    /**
     * @returns the receiver account.
     */
    get to() {
        return this._to;
    }
    /**
     * @returns the token volume of this transfer.
     */
    get quantity() {
        return this._quantity;
    }
    /**
     * @returns the token symbol.
     */
    get symbol() {
        return this._symbol;
    }
    /**
     * @returns the chain.
     */
    get chain() {
        return this._chain;
    }
    /**
     * @returns the token contract.
     */
    get contract() {
        return this._contract;
    }
    /**
     * @returns the datetime of this transfer.
     */
    get time() {
        return this._time;
    }
    /**
     * @returns the block number of the transaction.
     */
    get blockNum() {
        return this._blockNum;
    }
    /**
     * @returns the number of accumulated transfers.
     */
    get count() {
        return this._count;
    }
    /**
     * @returns the transaction id.
     */
    get trxId() {
        return this._trxId;
    }
    /**
     * @returns the memo.
     */
    get memo() {
        return this._memo;
    }
}
exports.Transfer = Transfer;
//# sourceMappingURL=Transfer.js.map